<template lang="pug">
div
  page-title(title="Solicitações de afilicação" icon="far fa-clock")
    div(slot="actions")
      button.btn.btn-primary.float-right(v-if="!filiationAlreadyRequested" @click="newFiliationRequest") Nova solicitação
  div
    requests-list(v-if="!loading" :list="list" @show="showFiliationRequest" @cancel="cancelFiliationRequest")
    router-view
</template>

<script>
import { mapState, mapActions } from 'vuex'
import RequestsList from './request/List'
import PageTitle from '@/components/layout/PageTitle'

export default {
  data() {
    return {
      showModal: false,
    }
  },

  components: { RequestsList, PageTitle },

  computed: {
    ...mapState('request', ['list', 'loading']),

    filiationAlreadyRequested() {
      const { list } = this

      if (!list.rows) return false
      return this.list.rows.some(item => item.status !== 'denied')
    },
  },

  methods: {
    ...mapActions('request', ['fetchList', 'request', 'cancelRequest']),

    async fetchRequestsList() {
      try {
        this.fetchList()
      } catch (e) {
        this.$toaster.error('Erro ao carregar lista')
      }
    },

    async newFiliationRequest() {
      const options = {
        title: 'Novo pedido de afiliação',
        okLabel: 'Sim',
        cancelLabel: 'Cancelar',
      }

      const { ok } = await this.$dialogs.confirm(
        'Deseja requisitar um novo pedido de afiliação?',
        options,
      )

      if (!ok) return

      try {
        await this.request()
      } catch (e) {
        this.$toaster.error('Erro ao requisitar novo pedido de afiliação')
      }
    },

    async showFiliationRequest(filiationRequestId) {
      this.$router.push({
        name: 'showRequest',
        params: { filiationRequestId },
      })
    },

    async cancelFiliationRequest(filiationRequestId) {
      const options = {
        title: 'Cancelar pedido de afiliação',
        okLabel: 'Sim',
        cancelLabel: 'Não',
      }

      const { ok } = await this.$dialogs.confirm(
        `Deseja cancelar o pedido de afiliação com o ID ${filiationRequestId}?`,
        options,
      )

      if (!ok) return

      try {
        await this.cancelRequest(filiationRequestId)
      } catch (e) {
        this.$toaster.error('Erro ao cancelar pedido de afiliação')
      }
    },
  },

  async created() {
    await this.fetchRequestsList()
  },
}
</script>
